import {
  CButton,
  CCard,
  CCardHeader,
  CCol,
  CFormInput,
  CFormLabel,
  CFormSwitch,
  CFormTextarea,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow
} from '@coreui/react';
import imageCompression from 'browser-image-compression';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
import FilePondPluginImageValidateSize from 'filepond-plugin-image-validate-size';
import 'filepond/dist/filepond.min.css';
import { useEffect, useRef, useState } from 'react';
import { FilePond, registerPlugin } from 'react-filepond';
import { importMockImage, mockImages } from 'src/reusables/MockImages';

import Moment from 'moment';
import { useLocation, useNavigate } from 'react-router-dom';
import Select from 'react-select';
import { Toaster } from 'src/components/Toaster';
import { create, getCategories, getFrameById, update, uploadFrames, uploadNumberedFrame } from 'src/services/Frames';
import FrameCanvas from './canvas/FrameCanvas';

import { Grid } from '@mui/material';

async function url2Blob(url) {
  return await (await fetch(url)).blob();
}

function AdjustFrame() {
  const [imageURL, setImageURL] = useState('');
  const [isUploading, setIsUploading] = useState(false);
  const [frameURL, setFrameURL] = useState('');
  const [frameName, setFrameName] = useState('');
  const [selectImageModal, setSelectImageModal] = useState(false);
  const [photoCount, setPhotoCount] = useState(6);
  const [isDuplicate, setIsDuplicate] = useState(true);
  const [isFrameInBack, setIsFrameInBack] = useState(false);
  const [useURL, setUseURL] = useState(false);
  const [useURLTemplate, setUseURLTemplate] = useState(false);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [color, setColor] = useState('');
  const [files, setFiles] = useState('');
  const [buttonUploadDisabled, setButtonUploadDisabled] = useState(false);
  const [masterCategories, setMasterCategories] = useState([]);
  const [optionCategories, setOptionCategories] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState(0);
  const [templateContainers, setTemplateContainers] = useState(photoCount === 6 ? importMockImage(6) : mockImages);
  const [images, setImages] = useState({});
  const [photoContainers, setPhotoContainers] = useState(mockImages ? importMockImage(6) : mockImages);
  const [uploaded, setUploaded] = useState(false);
  const [isTemplateUploaded, setIsTemplateUploaded] = useState(false);
  const [layout, setLayout] = useState([]);
  const [testLayoutClicked, setTestLayoutClicked] = useState(false);
  const [JSONLayout, setJSONLayout] = useState(false);
  const [isAddImageClicked, setIsAddImageClicked] = useState(false);
  const [isSaveClicked, setIsSaveClicked] = useState(false);
  const [isJSONValidated, setIsJSONValidated] = useState(false);

  const [templateFrameSaved, setTemplateFrameSaved] = useState(false);
  const [templateFrameURL, setTemplateFrameURL] = useState('');

  const [withFrame, setWithFrame] = useState(true);

  const navigate = useNavigate();
  const location = useLocation();

  const focusRef = useRef(null);
  const canvasRef = useRef(null);

  async function fetchCategories() {
    await getCategories().then((response) => {
      const catData = response.data.map((item, _) => {
        return { ...item, value: item.id, label: item.name };
      });

      setMasterCategories(catData);
      setOptionCategories(catData);

      if (location.state?.id) {
        fetchFrameById(location.state.id, catData);
      }
    });
  }

  function safeJSONParse(jsonString) {
    try {
      setIsJSONValidated((prev) => true);
      return JSON.parse(jsonString);
    } catch (error) {
      setIsJSONValidated((prev) => false);
      console.error('JSON parsing error:', error);
      return null; // or any other appropriate value or action
    }
  }

  async function fetchFrameById(id, categories) {
    await getFrameById(id).then((response) => {
      const res = response.data[0];
      setUseURL(true);
      setFrameName(res.name);
      setFrameURL(res.thumbnail_png_url);
      setImageURL(res.image_url);
      setPhotoCount(res.image_count);
      setIsDuplicate(res.is_duplicate == 1);
      setLayout(res.layout);
      const cat = categories.find((category) => category.id == res.category_id);
      setSelectedCategories(cat);
    });
  }

  useEffect(() => {
    fetchCategories();
  }, []);

  useEffect(() => {
    const tmp = {};
    for (let index = 0; index < photoCount / (isDuplicate ? 2 : 1); index++) {
      tmp[`${index}`] = 0;
    }
    setImages(tmp);
  }, [photoCount, isDuplicate]);

  useEffect(() => {
    if (!isUploading && templateFrameURL !== '') {
      handleAddFrame();
    }
  }, [isUploading]);

  function handleAddImage(i) {
    const tmp = {};
    for (let index = 0; index < photoCount / (isDuplicate ? 2 : 1); index++) {
      tmp[`${index}`] = images[index] + (index == i ? 1 : 0);
    }
    setImages(tmp);
  }

  function handleRemoveImage(i) {
    const tmp = {};
    for (let index = 0; index < photoCount / (isDuplicate ? 2 : 1); index++) {
      tmp[`${index}`] = images[index] - (index == i ? 1 : 0);
    }
    setImages(tmp);
  }

  async function handleAddFrame() {
    const data = {
      categoryID: selectedCategories.value,
      name: frameName,
      thumbnailPngURL: frameURL,
      thumbnailURL: templateFrameURL,
      imageURL: imageURL,
      imageCount: photoCount,
      isDuplicate: isDuplicate ? 1 : 0,
      active: 1,
      layout
    };

    var res;

    if (location.state) {
      res = await update({ id: location.state.id, ...data });
    } else {
      res = await create(data);
    }

    if (res.data.success === '1' || res.data.success === 1) {
      setMessage('Succeed');
      setOpen(true);
      setColor('green');
      setTimeout(() => {
        navigate(0);
      }, 2000);
    } else {
      setIsSaveClicked(false);
      setMessage('Not Succeed');
      setOpen(true);
      setColor('red');
    }
  }

  registerPlugin(
    FilePondPluginImageExifOrientation,
    FilePondPluginImagePreview,
    FilePondPluginImageValidateSize,
    FilePondPluginFileValidateSize
  );

  async function saveTemplateFrame(data) {
    const dataBlob = await url2Blob(data);
    uploadTemplate(dataBlob);
  }

  async function uploadTemplate(data) {
    setMessage('Uploading, Please Wait');
    setIsUploading(true);
    setOpen(true);
    setColor('green');
    const options = {
      maxSizeMB: 1, // (default: Number.POSITIVE_INFINITY)
      maxWidthOrHeight: 3000 // compressedFile will scale down by ratio to a point that width or height is smaller than maxWidthOrHeight (default: undefined)
    };

    const compressedFile = await imageCompression(data, options);
    let momentDate = Moment(new Date()).format('YYYYMMDD-HHmmss');

    const response = await uploadNumberedFrame(compressedFile, ``, '', momentDate);
    if (response.data.success === 1) {
      setTemplateFrameURL(response?.data.resUrl);
      setMessage(response?.data.message);
      setTemplateFrameSaved(true);
      setIsTemplateUploaded(true);
      setIsUploading(false);
      setUseURL(true);
      return 'success';
    } else {
      setTemplateFrameURL(response?.data.resUrl);
      setMessage(response?.data.message);
      setTemplateFrameSaved(true);
      setIsUploading(false);
      return 'false';
    }
  }

  async function upload() {
    setMessage('Uploading, Please Wait');
    setOpen(true);
    setColor('green');
    const options = {
      maxSizeMB: 2, // (default: Number.POSITIVE_INFINITY)
      maxWidthOrHeight: 3000 // compressedFile will scale down by ratio to a point that width or height is smaller than maxWidthOrHeight (default: undefined)
    };

    setButtonUploadDisabled(true);

    const compressedFile = await imageCompression(files[0].file, options);
    let momentDate = Moment(new Date()).format('YYYYMMDD-HHmmss');

    const response = await uploadFrames(compressedFile, ``, '', momentDate);

    if (response.data.success === 1) {
      setFrameURL(response?.data.resUrl);
      setMessage(response?.data.message);
      setButtonUploadDisabled(false);
      setSelectImageModal(false);
      setOpen(false);
      setColor('green');
      setUploaded(true);
      setUseURL(true);
    } else {
      setMessage(response?.data.message);
      setOpen(false);
      setButtonUploadDisabled(false);
      setSelectImageModal(false);
    }
  }

  function validateForm() {
    if (frameURL === '' || !frameURL.includes('sukha')) {
      return false;
    }
    if (frameName === '') {
      return false;
    }
    if (imageURL === '' || !imageURL.includes('.png')) {
      return false;
    }
    if (selectedCategories == 0) {
      return false;
    }
    if (photoCount == '') {
      return false;
    }
    if (layout === '') {
      return false;
    }
    if (isFrameInBack) {
      return false;
    }
    if (isSaveClicked) {
      return false;
    }
    return true;
  }

  return (
    <div style={{ color: 'black', paddingBottom: 20 }}>
      <Toaster open={open} setOpen={setOpen} message={message} ahd={1500} color={color ?? 'red'} />

      <CModal visible={selectImageModal} onClose={() => setSelectImageModal(false)} size="lg">
        <CModalHeader closeButton>
          <CModalTitle>Upload Frame</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <FilePond
            instantUpload={false}
            files={files}
            onupdatefiles={setFiles}
            allowMultiple={false}
            maxFiles={1}
            allowFileSizeValidation={true}
            // maxFileSize='1MB'
            labelMaxFileSizeExceeded="File is too large"
            imageTransformOutputQuality={30}
            // server="/api"
            name="files"
            labelIdle='Drag & Drop file atau <span class="filepond--label-action">Browse</span>'
          />
        </CModalBody>
        <CModalFooter>
          <CButton disabled={buttonUploadDisabled} onClick={() => upload()}>
            Upload
          </CButton>
        </CModalFooter>
      </CModal>
      <CCard>
        <CCardHeader>Adjust Frame</CCardHeader>
        <CRow>
          <CCol style={{ margin: '16px' }}>
            <Grid item style={{ backgroundColor: '#D0D0D0' }}>
              <FrameCanvas
                ref={canvasRef}
                showFrame={withFrame}
                isFrameInBack={isFrameInBack}
                nImage={photoCount}
                isDuplicate={isDuplicate}
                images={images}
                onImageRemove={handleRemoveImage}
                frameURL={frameURL}
                setLayout={setLayout}
                uploadImage={saveTemplateFrame}
                testLayoutClicked={testLayoutClicked}
                setTestLayoutClicked={setTestLayoutClicked}
                isAddImageClicked={isAddImageClicked}
                setIsAddImageClicked={setIsAddImageClicked}
                isSaveClicked={isSaveClicked}
                setIsSaveClicked={setIsSaveClicked}
              />
            </Grid>
          </CCol>
          <CCol style={{ margin: '16px' }}>
            <CFormLabel style={{ marginTop: '1vh' }}>Use URL</CFormLabel>
            <CFormSwitch
              value={useURL}
              onChange={(e) => {
                setUseURL(!useURL);
              }}
              defaultChecked={location.state ? location.state : false}
            />
            {useURL ? (
              <>
                <CFormLabel style={{ marginTop: '1vh' }}>Frame URL</CFormLabel>
                <CFormInput
                  type="text"
                  value={frameURL}
                  disabled={uploaded}
                  onChange={(e) => setFrameURL(e.target.value)}
                />
              </>
            ) : (
              <CRow className="mb-3">
                <CFormLabel style={{ marginTop: '1vh' }}>Upload Frame</CFormLabel>
                <CCol>
                  <CButton
                    // feedbackInvalid= {parseInt(selectedCategory.value) === 1}
                    onClick={(e) => {
                      setSelectImageModal(true);
                    }}
                  >
                    {frameURL.includes('https://ik.imagekit.io/sukhakala/') ||
                    frameURL.includes('https://ik.imagekit.io/sukhakala2/')
                      ? 'Change Frame'
                      : 'Upload Frame'}
                  </CButton>
                </CCol>
              </CRow>
            )}
            <>
              <CFormLabel style={{ marginTop: '1vh' }}>Frame Name</CFormLabel>
              <CFormInput type="text" value={frameName} onChange={(e) => setFrameName((prev) => e.target.value)} />
            </>
            <>
              <CFormLabel style={{ marginTop: '1vh' }}>File Name</CFormLabel>
              <CFormInput type="text" value={imageURL} onChange={(e) => setImageURL((prev) => e.target.value)} />
            </>

            <CRow>
              <CFormLabel style={{ marginTop: '1vh' }}>Select Frame Categories</CFormLabel>
              <Select
                options={optionCategories}
                value={selectedCategories}
                onChange={(e) => {
                  setSelectedCategories(e);
                  let filtered = masterCategories.filter((item) => {
                    return item.value !== e?.value;
                  });
                  setOptionCategories(filtered);
                }}
              />
            </CRow>

            <CFormLabel style={{ marginTop: '1vh' }}>Image Count</CFormLabel>
            <CFormInput
              type="text"
              value={photoCount}
              onChange={(e) => {
                if (e.target.value > 8) {
                  setPhotoCount(8);
                } else {
                  setPhotoCount((prev) => e.target.value);
                }
                setPhotoContainers((prev) => importMockImage(e.target.value));
                const getMockImage = importMockImage(e.target.value);

                const forTemplateContainers = { ...getMockImage };

                setTemplateContainers((prev) => forTemplateContainers);
              }}
            />

            <CFormLabel style={{ marginTop: '1vh' }}>Is Duplicate</CFormLabel>
            <CFormSwitch
              value={isDuplicate}
              onChange={(e) => {
                setIsDuplicate(!isDuplicate);
              }}
              defaultChecked
            />

            <CFormLabel style={{ marginTop: '1vh' }}>Show JSON Layout</CFormLabel>
            <CFormSwitch
              value={JSONLayout}
              onChange={(e) => {
                setJSONLayout(!JSONLayout);
                setTestLayoutClicked(true);
              }}
            />

            {JSONLayout ? (
              <Grid position={'relative'}>
                <CFormLabel style={{ marginTop: '1vh' }}>Layout</CFormLabel>
                <CFormTextarea
                  readOnly
                  value={layout}
                  style={{ height: '20vh' }}
                  onChange={(e) => {
                    setLayout(e.target.value);
                    const a = photoContainers;

                    const jsonParse = safeJSONParse(e.target.value);

                    if (jsonParse !== null) {
                      setPhotoContainers(JSON.parse(e.target.value));
                    } else {
                      setPhotoContainers(a);
                    }
                  }}
                />
                <CButton
                  style={{
                    position: 'absolute',
                    right: 25,
                    bottom: 10
                  }}
                  onClick={() => setTestLayoutClicked(true)}
                >
                  Refresh Layout
                </CButton>
              </Grid>
            ) : (
              <></>
            )}

            {
              <>
                <CFormLabel style={{ marginTop: '1vh' }}>Use URL For Template</CFormLabel>
                <CFormSwitch value={useURLTemplate} onChange={(e) => setUseURLTemplate(!useURLTemplate)} />

                {useURLTemplate ? (
                  <>
                    <CFormLabel style={{ marginTop: '1vh' }}>Frame URL</CFormLabel>
                    <CFormInput
                      type="text"
                      value={templateFrameURL}
                      onChange={(e) => setTemplateFrameURL(e.target.value)}
                    />
                  </>
                ) : templateFrameSaved ? (
                  <>
                    <CFormLabel style={{ marginTop: '1vh' }}>Template URL</CFormLabel>
                    <CFormInput
                      type="text"
                      value={templateFrameURL}
                      disabled={isTemplateUploaded}
                      onChange={(e) => setTemplateFrameURL(e.target.value)}
                    />
                  </>
                ) : (
                  <></>
                )}
              </>
            }
            <CRow>
              <CFormLabel>Add Images</CFormLabel>
              <Grid>
                {[...Array(Math.floor(photoCount / (isDuplicate ? 2 : 1)))].map((e, i) => (
                  <CButton
                    key={`button-${i}`}
                    style={{ marginRight: '10px', marginBottom: '10px' }}
                    onClick={() => {
                      handleAddImage(i);
                    }}
                    disabled={images[i] >= (isDuplicate ? 2 : 1)}
                  >
                    {`#${i + 1}`}
                  </CButton>
                ))}
              </Grid>
            </CRow>

            <Grid>
              <CButton
                style={{ borderColor: 'primary', marginTop: '2vh', marginRight: '2vw' }}
                onClick={() => {
                  setWithFrame(!withFrame);
                }}
                disabled={frameURL === ''}
              >
                Show/Hide Frame
              </CButton>
              <CButton
                style={{ borderColor: 'primary', marginTop: '2vh', marginRight: '2vw' }}
                onClick={() => {
                  setIsFrameInBack(!isFrameInBack);
                }}
                disabled={frameURL === ''}
              >
                Send Frame to Back/Front
              </CButton>
              <CButton
                // disabled={templateFrameURL === "" || !templateFrameURL.includes("sukhakala")}
                disabled={!validateForm()}
                style={{ borderColor: 'primary', marginTop: '2vh' }}
                onClick={() => {
                  setIsFrameInBack(false);
                  setIsSaveClicked(true);
                }}
              >
                Submit Frame
              </CButton>
            </Grid>
          </CCol>
        </CRow>
      </CCard>
    </div>
  );
}

export default AdjustFrame;
